import featureShape01 from '../../../../Images/background/feature-shape-3.png';
import featureShape04 from '../../../../Images/background/feature-shape-4.png';
import featureShape05 from '../../../../Images/background/feature-shape-5.png';
import featureShape06 from '../../../../Images/background/feature-shape-6.png';
import featureicons03 from '../../../../Images/icons/24-hours.png';
import featureicons06 from '../../../../Images/icons/consultant.png';
import featureicons05 from '../../../../Images/icons/interview.png';
import featureicons01 from '../../../../Images/icons/live-streaming.png';
import featureicons04 from '../../../../Images/icons/money-bag.png';
import featureicons02 from '../../../../Images/icons/posting.png';
import SectionTitle from '../../../SectionTitle/SectionTitle';
import './Featured.css';

const Featured = () => {
  return (
    <section className='pb-[100px] pt-[100px] featured-background'>
      <div className='shapes'>
        <div className='shape-1'>
          <img src={featureShape01} alt='shape' />
        </div>
        <div className='shape-2'>
          <img src={featureShape04} alt='shape' />
        </div>
        <div className='shape-3'>
          <img src={featureShape05} alt='shape' />
        </div>
        <div className='shape-4'>
          <img src={featureShape06} alt='shape' />
        </div>
      </div>
      <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
        <SectionTitle
          title='Why Is M. Solaiman The Best Choice ?'
          subtitle='Why Choose Us'
        />
        <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3'>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons01}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                100% Practical-Based Training
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              Our training programs focus heavily on hands-on practice through
              intensive lab sessions. This practical approach ensures you
              develop job-ready skills that meet current industry and employer
              demands.
            </p>
          </div>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons02}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                Job Placement Assistance
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              We offer dedicated career support, including job placement
              assistance and interview preparation. Our goal is to help students
              transition smoothly from training to successful employment.
            </p>
          </div>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons03}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                Full Facilities Including Hostel
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              Our institute is equipped with modern laboratories and fully
              functional workshops. Comfortable on-site hostel facilities ensure
              a safe, convenient, and distraction-free learning environment for
              students.
            </p>
          </div>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons04}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                Affordable Course Fees
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              We believe quality education should be accessible to everyone. Our
              courses are offered at affordable fees without compromising on
              training quality or facilities.
            </p>
          </div>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons05}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                Skilled & Experienced Instructors
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              Learn from highly skilled instructors with over a decade of
              real-world industry experience. They provide in-depth, practical
              guidance and mentorship, helping you master advanced skills such
              as 6G Welding with confidence.
            </p>
          </div>
          <div className='bg-white relative featured-card rounded-[15px] p-[30px] border-2 border-transparent transition-all duration-300 ease-in-out hover:border-primary '>
            <div className='flex mb-[25px] items-center gap-4'>
              <div className='bg-primary w-[70px] h-[70px] flex items-center justify-center rounded-[10px]'>
                <img
                  className='w-[45px] h-[45px] object-cover icons-card'
                  src={featureicons06}
                  alt='icons'
                />
              </div>
            </div>
            <div>
              <h3 className='mb-4 text-[23px] cursor-pointer leading-7 font-semibold text-[#162726] hover:text-primary transition-all duration-300 ease-in-out'>
                Guidance Directly From Mentors
              </h3>
            </div>
            <p className='text-[#6C706F] text-[15px] mb-0 font-medium'>
              If any issues arise during the course, solutions are available
              from our seasoned mentors solely during designated support hours.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featured;
